import { React } from 'react';
import { Box } from '@mui/material';
import { disableContextMenu, AccountUsersSearch } from '../..';

function AccountUsers(props) {
    return (
        <Box sx={{ height: '100%' }} onContextMenu={disableContextMenu}>
            <AccountUsersSearch {...props} />
        </Box>
    );
}

export { AccountUsers };
